var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ElementRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractComponent } from 'gp-admin-abstract';
var TextareaComponent = /** @class */ (function (_super) {
    __extends(TextareaComponent, _super);
    function TextareaComponent(el) {
        var _this = _super.call(this, el) || this;
        _this.el = el;
        /**
         * Имя поля, предназначено для того, чтобы обработчик формы мог его идентифицировать
         *
         * @type {string}
         */
        _this.name = '';
        /**
         * Заголовок компонента
         *
         * @type {string}
         */
        _this.title = '';
        /**
         * Текст ошибки
         *
         * @type {boolean}
         */
        _this.error = false;
        /**
         * Состояние компонента
         *
         * @type {boolean}
         */
        _this.disabled = false;
        _this.propagateChange = function (_) {
        };
        return _this;
    }
    TextareaComponent.prototype.writeValue = function (value) {
        this.value = value;
    };
    TextareaComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    TextareaComponent.prototype.registerOnTouched = function (fn) {
    };
    TextareaComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    TextareaComponent.prototype.change = function () {
        this.propagateChange(this.value);
    };
    TextareaComponent.prototype.showErrorText = function () {
        return ((typeof this.error === 'string') && !!this.error);
    };
    TextareaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'gp-textarea',
                    template: "\n<div [ngClass]=\"\n                'gp-textarea ' + extraClass +\n                (disabled ? ' gp-textarea--disabled ' : '') +\n                (!!value ? ' gp-textarea--filled ' : '') +\n                (!!error ? ' gp-textarea--error ' : '')\n\">\n\n    <div class=\"flex flex--content-between\">\n        <div class=\"gp-textarea__title\" *ngIf=\"!!title\">{{ title }}</div>\n        <div class=\"gp-textarea__error\" *ngIf=\"showErrorText()\">{{ error }}</div>\n    </div>\n\n    <textarea\n            class=\"gp-textarea__area\"\n            [name]=\"name\"\n            [cols]=\"cols\"\n            [rows]=\"rows\"\n            [disabled]=\"disabled\"\n            [(ngModel)]=\"value\"\n            (ngModelChange)=\"change()\"\n    ></textarea>\n\n    <!--TODO: AlexFoxJS: \u0435\u0441\u043B\u0438 \u043D\u0430\u0434\u043E \u0431\u0443\u0434\u0435\u0442 - maxLength \u0432\u0435\u0440\u0441\u0442\u043A\u0430-->\n\n</div>\n",
                    styles: [
                        "@charset \"UTF-8\";\n/**\n * \u041F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435\n */\n:root {\n  --color-white: white;\n  --color-success: #00afec;\n  --color-warning: #ffb827;\n  --color-error: #f35252;\n  --color-disabled: #dbdbdb;\n  --color-black: black;\n  --color-span: #b5b5b5;\n  --color-span-second: #212121;\n  --color-bg: #f8f8f8;\n  --color-bg-second: #f8f8f8;\n  --color-bg-success: rgba(0, 175, 236, 0.1);\n  --color-bg-warning: var(--color-warning);\n  --color-bg-error: var(--color-error);\n  --color-placeholder: #b5b5b5;\n  --color-border: #dbdbdb;\n  --color-radio-border: #d3d3d3;\n  --font-roboto: 'Roboto', sans-serif;\n  --font-helvetica: 'Helvetica', sans-serif; }\n\n/**\n *\n */\n/**\n * \u0421\u0442\u0438\u043B\u0438 \u0434\u043B\u044F \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430 \"gp-textarea\"\n */\n.gp-textarea {\n  display: inline-block;\n  width: 100%; }\n  .gp-textarea--success textarea.gp-textarea__area:focus {\n    border-color: #00afec;\n    outline-color: #00afec; }\n  .gp-textarea--success .gp-textarea__title {\n    color: #00afec; }\n  .gp-textarea--error textarea.gp-textarea__area:focus {\n    border-color: #f35252;\n    outline-color: #f35252; }\n  .gp-textarea--error .gp-textarea__title {\n    color: #f35252; }\n  .gp-textarea--error .gp-textarea__error {\n    display: block; }\n  .gp-textarea--disabled textarea.gp-textarea__area {\n    cursor: not-allowed;\n    color: #b5b5b5;\n    border-color: #dbdbdb;\n    background-color: #f8f8f8; }\n  .gp-textarea__title {\n    font: 500 1.2rem/1.4rem \"Roboto\", sans-serif;\n    margin-bottom: 0.5rem;\n    color: #b5b5b5;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n  .gp-textarea__error {\n    font: 500 1.2rem/1.4rem \"Roboto\", sans-serif;\n    display: none;\n    color: #f35252; }\n  .gp-textarea__area {\n    font: 1.3rem/1.5rem \"Roboto\", sans-serif;\n    min-width: 18rem;\n    width: 100%;\n    padding: 0.9rem 1.5rem;\n    border: 0.1rem solid #dbdbdb;\n    border-radius: 0.2rem;\n    background-color: var(--color-white); }\n  .gp-textarea textarea::-webkit-input-placeholder {\n    color: #b5b5b5; }\n  .gp-textarea textarea:-ms-input-placeholder {\n    color: #b5b5b5; }\n  .gp-textarea textarea::placeholder {\n    color: #b5b5b5; }\n"
                    ],
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: TextareaComponent,
                            multi: true
                        }
                    ],
                },] },
    ];
    /** @nocollapse */
    TextareaComponent.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    TextareaComponent.propDecorators = {
        'rows': [{ type: Input },],
        'cols': [{ type: Input },],
        'name': [{ type: Input },],
        'title': [{ type: Input },],
        'error': [{ type: Input },],
        'value': [{ type: Input },],
        'disabled': [{ type: Input },],
        'maxLength': [{ type: Input },],
    };
    return TextareaComponent;
}(AbstractComponent));
export { TextareaComponent };
//# sourceMappingURL=textarea.component.js.map